import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ColorConverterService {
    private readonly hexRegExp = /^#?(?<red>[a-f\d]{2})(?<green>[a-f\d]{2})(?<blue>[a-f\d]{2})$/i;
    private readonly rgbRegExp = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*(\d*\.?\d+))?\s*\)$/i;

    public hexToRgb(hex: string): string | null {
        const result = hex.match(this.hexRegExp);
        if (!result?.groups) {
            return null;
        }
        const { red, green, blue } = result.groups;
        const r = parseInt(red, 16);
        const g = parseInt(green, 16);
        const b = parseInt(blue, 16);

        return `rgb(${r},${g},${b})`;
    }

    public parseRGB(rgbString: string): { blue: number; green: number; red: number } | null {
        const match = rgbString.match(this.rgbRegExp);

        if (!match) {
            return null;
        }

        const [, r, g, b] = match;

        return {
            blue: parseInt(b),
            green: parseInt(g),
            red: parseInt(r),
        };
    }

    public rgbToHex(red: number, green: number, blue: number): string {
        return `#${this.componentToHex(red)}${this.componentToHex(green)}${this.componentToHex(blue)}`;
    }

    private componentToHex(component: number): string {
        const hex = component.toString(16);

        return hex.length === 1 ? `0${hex}` : hex;
    }
}
